import { WSSocketListener } from '~/web-frontend-core/api/connector/socketListener/WSS';
import { XHRSocketListener } from '~/web-frontend-core/api/connector/socketListener/XHR';
import { CHANNEL_ACTION, SITE_TYPE } from '~/web-frontend-core/api/const/base';
import { Queue } from '~/web-frontend-core/base/lib';
import Logger from '~/web-frontend-core/devtools/logger';
import { subscriptions } from './socketListener/socket/Axios';
const RECONNECT_INTERVAL_MS = 3000;
/**
 * @class
 * @abstract
 * Предназначен для подключения экземпляров {@link BaseSocketListener}
 *  - содержит общую информацию для подключения (тип данных, тип сайта, временная зона, язык)
 *  - управляет переподпиской упавших сокетов, очередностью их подключения
 */
export class BaseSocketConnector {
    constructor(outcomeData, 
    /** Сокеты подключения в порядке приоритета */
    /** Приоритет подключения сокетов */
    SocketListenersPriority = [WSSocketListener, XHRSocketListener]) {
        this.siteType = SITE_TYPE.COM;
        this.socketListener = null;
        this.timezone = 0;
        this.language = 0;
        this.isConnectionSelfClosable = false;
        this.jwtProvider = null;
        this.timezone = (outcomeData === null || outcomeData === void 0 ? void 0 : outcomeData.timezone) || this.timezone;
        this.siteType = (outcomeData === null || outcomeData === void 0 ? void 0 : outcomeData.site) || this.siteType;
        this.language = (outcomeData === null || outcomeData === void 0 ? void 0 : outcomeData.lng) || this.language;
        this.socketListenersQueue = new Queue(SocketListenersPriority);
    }
    /**
     * Установка источника для JWT
     * @param jwtProvider
     */
    setJwtProvider(jwtProvider) {
        this.jwtProvider = jwtProvider;
    }
    /**
     * Установка языка
     * @param language
     */
    setLanguage(language) {
        this.language = language;
    }
    /**
     * Подписка на получение данных
     * @param cfg
     */
    subscribe(cfg) {
        const logger = Logger.getInstance();
        if (!this.socketListener) {
            this.createSocketListener(cfg.onerror);
        }
        if (!this.socketListener || !this.createMessage(cfg).d) {
            this.resubscribe(cfg, RECONNECT_INTERVAL_MS);
            /** больше нет сокетов для подключения */
            cfg.onclose && cfg.onclose();
            return;
        }
        const onerror = (e) => {
            cfg.onerror && cfg.onerror(new Error(`${this.constructor.name}: ${e instanceof Error ? e.message : e.type}`));
            this.unsubscribe(Object.assign({}, cfg), 'onerror').then(() => {
                // this.socketListenersQueue.next();
                // this.createSocketListener(cfg.onerror);
                // this.subscribe(cfg);
                this.resubscribe(cfg, RECONNECT_INTERVAL_MS);
            });
        };
        this.socketListener.subscribe(this.createMessage(cfg), {
            onmessage: (msg) => {
                var _a;
                const response = JSON.parse(msg.data);
                if (response.t !== this.dataTypeCode) {
                    return;
                }
                if (response.d && Object.prototype.hasOwnProperty.call(response.d, "error")) {
                    cfg.onerror && cfg.onerror(new Error((_a = response.d) === null || _a === void 0 ? void 0 : _a.error));
                }
                else {
                    cfg.onmessage && cfg.onmessage(response.d);
                }
            },
            onopen: (e) => {
                logger.log(`${this.constructor.name}: ${e.type}`);
                cfg.onopen && cfg.onopen(e);
            },
            onclose: (e) => {
                logger.log(`${this.constructor.name}: ${e.type}`);
                if (this.isConnectionSelfClosable)
                    return;
                onerror(e);
            },
            onerror(e) {
                logger.error(new Error(`${this.constructor.name}: ${e instanceof Error ? e.message : e.type}`));
                onerror(e);
            },
        });
    }
    /**
     * Отписка от получения данных
     * @param cfg
     */
    unsubscribe({ subscriptionID: s_id }, target) {
        clearTimeout(this.resubscribeTimeout);
        if (!target) {
            subscriptions.remove(this.dataTypeCode);
        }
        return this.socketListener ?
            this.socketListener.unsubscribe({
                t: this.dataTypeCode,
                op: CHANNEL_ACTION.UNSUBSCRIBE,
                s_id
            }, target) : Promise.resolve();
    }
    /**
     * Отложенная переподписка с приоритетного сокета
     * @param cfg
     * @param delay задержка в мс
     */
    resubscribe(cfg, delay = 0) {
        this.resubscribeTimeout = window.setTimeout(() => {
            const logger = Logger.getInstance();
            this.socketListenersQueue.reset();
            this.createSocketListener(logger.error);
            logger.log(`[${this.socketListener}] Попытка восстановить соединение`);
            this.subscribe(cfg);
        }, delay);
    }
    createMessage(cfg) {
        return {
            d: this.getOutcomeData(cfg),
            t: this.dataTypeCode,
            op: CHANNEL_ACTION.SUBSCRIBE,
            s_id: cfg.subscriptionID
        };
    }
    createSocketListener(onerror) {
        try {
            this.socketListener = this.socketListenersQueue.current || null;
        }
        catch (e) {
            onerror && onerror(e);
            this.socketListenersQueue.next();
            this.createSocketListener(onerror);
        }
    }
    send(s, target) {
        var _a, _b;
        (_b = (_a = this === null || this === void 0 ? void 0 : this.socketListener) === null || _a === void 0 ? void 0 : _a.send) === null || _b === void 0 ? void 0 : _b.call(_a, s, target);
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/api/connector/BaseSocketConnector.js